import Helper from '@/Helper'
import ProfileService from '@/service/profile'
import QrCode from '@/components/qr-code'
// import Echo from 'laravel-echo'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'app-login',
  components: {QrCode, VueRecaptcha},
  props: [],
  data () {
    return {
      errors: [],
      message: '',
      user: {
        type: 1
      },
      btn_dangnhap: false,
      params: {},
      timeout: true
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   HTTP.get('/getuser').then(res => {
  //     next({path: '/'})
  //   }).catch(err => {
  //     console.log(err)
  //     next()
  //   })
  // },
  created () {
  },
  computed: {

  },
  mounted () {
    this.notifiResetPassword()
  },
  methods: {
    forgotPassword () {
      this.$router.replace('password/forgot')
    },
    notifiResetPassword () {
      // eslint-disable-next-line no-return-assign
      setTimeout(() => this.timeout = false, 5000)
    },
    login () {
      this.$loading.start()
      this.message = ''
      this.btn_dangnhap = true
      ProfileService.login(this.user).then(res => {
        if (res.status === 200) {
          this.$loading.complete()
          Helper.setUserLocalStorage(res.data.data)
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push('/')
          }
          this.btn_dangnhap = false
        }
      }).catch(err => {
        console.log(err.message)
        this.message = err.data.message
        this.$loading.complete()
        if (err.status === 422) {
          this.errors = err.data.message
        }
        if (err.status === 401) {
          this.message = 'Đăng nhập thất bại'
          this.$loading.fail()
        }
        this.btn_dangnhap = false
      })
    },
    getCaptcha (response) {
      this.user.captcha = response
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.component.js